module.exports = __webpack_public_path__ + "img/user-check.0bf0b63e.svg";